module.exports = __webpack_public_path__ + "img/ug561.d3eca6c0.png";